import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'
import useDebounce from '../../../../../utils/hooks/useDebounce'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
  master?: any
  skills: any
}

const Forms: React.FC<Props> = ({toggle, getData, editFormValue, master, skills}) => {
  const [loading, setLoading] = useState(false)
  const [formValue, setFormValue] = useState<any>({
    title: '',
    company_name: '',
    start_date: '',
    end_date: '',
    industries: '',
    description: '',
  })
  const [disabled, setDisabled] = useState(false)
  const [file, setFile] = useState<any>(null)

  const [inputs, setInputs] = useState<any>([
    {
      name: 'skills',
      label: 'Keahlian Anda',
      type: 'select-creatable',
      validation: {},
      col: 12,
      options: skills,
      additional: '',
      getItemValue: 'skills_name',
      getItemValueId: 'skills_id',
    },
    {
      name: 'proficiencies_id',
      label: 'Tingkat Kemahiran',
      type: 'select2',
      validation: {},
      col: 6,
      options: master,
      additional: '',
      getItemValue: 'proficiencies_name',
      getItemValueId: 'proficiencies_id',
    },
    {
      name: 'total_experience',
      label: 'Lama Pengalaman',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: 'Tahun',
    },
    {
      name: 'is_certificate',
      label: 'Terdapat Sertifikat?',
      type: 'select2',
      validation: {},
      col: 6,
      options: [
        {
          name: 'Ya',
          value: 1,
        },
        {
          name: 'Tidak',
          value: 0,
        },
      ],
      getItemValue: 'name',
      getItemValueId: 'value',
    },
    {
      name: 'institution',
      label: 'Nama Institusi Penerbit Sertifikat (Opsional)',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'description',
      label: 'Deskripsi (Opsional)',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
    },
  ])

  useEffect(() => {
    setFormValue(editFormValue)
    disableUpload(editFormValue?.is_certificate)
  }, [editFormValue])

  useEffect(() => {
    let clone = inputs
    clone[0].items = skills
    clone[0].options = skills
    setInputs(clone)
  }, [skills])

  useEffect(() => {
    let clone = inputs
    clone[1].items = master
    clone[1].options = master
    setInputs(clone)
  }, [master])

  useDebounce(
    () => {
      getSkill('')
      getProficiency('')
    },
    250,
    []
  )

  const getSkill = async (q: any) => {
    try {
      const {data} = await MasterServices.getSkill({...{is_active: 1}, q})
      let clone = inputs
      clone[0].items = data.data
      clone[0].options = data.data
      setInputs(clone)
    } catch (error) {
    }
  }

  const getProficiency = async (q: any) => {
    try {
      const {data} = await MasterServices.getProficiency({...{type: ['SKILL'], is_active: 1}, q})
      let clone = inputs
      clone[0].items = data.data
      clone[0].options = data.data
      setInputs(clone)
    } catch (error) {
    }
  }

  const disableUpload = (value: number) => {
    let cloneForms = inputs
    cloneForms[4].disabled = value == 1 ? false : true
    setInputs(cloneForms)
    setDisabled(value == 1 ? false : true)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    if (name === 'upload') {
      setFile(e.target.files[0])
      return
    }

    if (name === 'is_certificate') {
      disableUpload(value.value)
    }

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const onSelect = (input: any, row: any, key: any) => {
    const name = input

    switch (name) {
      case 'skills':
        getSkill(row)
        break
    }
  }

  const uploadFile = async (id?: any) => {
    setLoading(true)
    await UserService.uploadFileSkill({file}, id)
      .then(() => {
        toast.success(`Skill Berhasil ${id ? 'Diperbarui' : 'Dibuat'}`)
        toggle()
        getData()
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const handleSubmit = async (e: any) => {
    e?.preventDefault()
    const formData = new FormData(e.target)
    const formProps = Object.fromEntries(formData)

    setLoading(true)

    await UserService.createOrUpdateSkill(formProps, editFormValue.rowDetail?.user_skills_id)
      .then((response) => {
        let id = editFormValue?.rowDetail?.user_skills_id ?? response.data?.user_skills_id
        if (file) {
          uploadFile(id)
          return
        }

        toast.success(`Skill Berhasil ${id ? 'Diperbarui' : 'Dibuat'}`)
        toggle()
        getData()
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>
          {master && FormGenerator(inputs, formValue, onChange, onSelect, loading)}
          <Col md={12}>
            <Row className='d-grid gap-4'>
              <Col md={12}>
                <Form.Label>Unggah Dokumen Pendukung (Opsional)</Form.Label>
              </Col>
              <Col md={12}>
                <input type='file' name='upload' disabled={disabled} onChange={onChange} />
              </Col>
              {formValue?.rowDetail?.document_url_full ? (
                <Col md={12}>
                  <a href={formValue?.rowDetail?.document_url_full} target='_blank'>
                    Dokumen Pendukung
                  </a>
                </Col>
              ) : null}
              <Col md={12}>
                <Form.Text>pdf Max file size is 2MB</Form.Text>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={loading}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={loading}>
            {loading ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default Forms
